// extracted by css-extract-rspack-plugin
export default {"fillViewport":"PV_A5vjoZb8Hov0C","description":"o57zaKKQrQ60fCQk","cards":"oRc0JjWAnTEMKZ1_"};